import React, { useEffect, useState } from "react";
import moment from "moment";
import { Paper } from "@material-ui/core";
import { useDispatch, useStore } from "react-redux";
import Grid from "@material-ui/core/Grid";

import plus from "assets/img/plus.png";
import netbox from "assets/img/netbox.png";
import topology from "assets/img/topology.png";
import xml from "assets/img/xml.png";
import yaml from "assets/img/yaml.png";
import Chatbot from 'views/Components/chatbot/Chatbot';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import CustomTable from "../../components/CustomTable/CustomTable";
import GridItem from "components/Grid/GridItem.js";
import { SHOW_LOADER, HIDE_LOADER } from "action_creators/actioncreator";
import CreateTemplateModal from "./Components/CreateTemplateModal";
import ImportFromWizard from "./Components/ImportFromWizard";
import ConfirmationModal from "./Components/ConfirmationModal";
import LoaderHoc from "components/HOC/LoaderHoc";

import {
  SET_WIZARDS,
  SHOW_NOTIFICATION,
} from "../../action_creators/actioncreator";
import {
  getAllWizards,
  getDesignerObjects,
  removeTemplate,
} from "../../apis/APIServices";
import "./Desgin.scss";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Zoom from "@material-ui/core/Zoom/Zoom";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import DesignCenterUpgrade from "../Components/DesignCenterUpgrade";
import { Alert } from "@material-ui/lab";
import { SET_NAVBAR_TITLE } from "action_creators/actioncreator";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ImportDesignModal from "./Components/ImportDesignModal";
import { SDCloudBackendAPIWithToken } from "../../apis/backendAPI";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import deleteicon from 'assets/img/deleteicon.png';
import "driver.js/dist/driver.css";
import { getTourBlockers } from "actions/TourManager";
import { fetchUserPermission } from "utils/userRolesService";
import { set } from "date-fns";
var initialColumns = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "User",
    accessor: "username",
  },
  {
    Header: "Date created",
    accessor: "created_at",
  },
  {
    Header: "Last used",
    accessor: "last_used",
  },
  {
    Header: "",
    accessor: "actions",
  },
];

const errPayload = {
  message: "Something went wrong.",
  color: "danger",
};

const useStyles = makeStyles((theme) => ({
  bgColor: {
    background: theme.palette.secondary.main,
  },
  font: {
    fontFamily: `${theme.palette.fontList.selectedFont} !important`,
  },
}));

const FeatureBox = ({
  action,
  className,
  active,
  icon,
  label,
  iconClass,
  font,
}) => (
  <Paper
    onClick={action || null}
    className={`feature-box ${active && "active"} ${className || ""}`}
    elevation={0}
  >
    <div>
      <span className="box-icon">
        <img src={icon} alt="icon" className={iconClass || ""} />
      </span>
    </div>
    <div className={`box-label ${font}`}>{label}</div>
  </Paper>
);

export default function Design() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = useStore();
  const reduxDesignStore = store.getState().design;
  const [rows, setRows] = useState([]);
  const [allWizards, setWizards] = useState({});
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [isNewTemplateVisible, setNewTemplateVisible] = useState(false);
  const [isNewTemplateWizardVisible, setNewTemplateWizardVisible] = useState(
    false
  );
  const [isImportModal, setIsImportModal] = useState(false);
  const [modalType, setModalType] = useState("XML");
  const [isConfirmModal, setConfirmModal] = useState(false);
  const [actionWizard, setActionWizard] = useState("");
  const [showNotification, setShowNotification] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [notificationMessage, setNotificationMessage] = useState("");
  const [rowstemp, setrowstemp] = useState([]);
  const [searchValue, setsearchvalue] = useState("");
  const [recordCount, setrecordCount] = useState(10);
  const [pageNo, setpageNo] = useState(1);
  const [listvalue, setlistvalue] = useState("");
  const profileData = JSON.parse(localStorage.getItem("profileData"));
  const account = profileData.account;
  let domain = JSON.parse(localStorage.getItem("internal_domains"))?.domains;
  let userEmail = JSON.parse(localStorage.getItem("profileData"))?.email;
  let hasDomain = domain?.some((res) => userEmail.includes(res));
  const [isInternal, setIsInternal] = useState(hasDomain);
  const [loading, setLoading] = useState(true);
  const [is_designer_enabled, setIsDesignerEnabled] = useState(false);
  const [columns, setColumns] = useState(initialColumns);

  async function getEnabledRoles() {
    try {
      // check designer access via the dedicated designer_portal permission check
      const profileName = profileData?.profile_name;
      if (profileName) {
        const hasDesignerAccess = await fetchUserPermission(profileName);
        console.log("Designer access:", hasDesignerAccess);
        setIsDesignerEnabled(hasDesignerAccess);
      }

      const storedRoles = sessionStorage.getItem("enabled_roles");
      const userEnabledRoles = storedRoles ? JSON.parse(storedRoles) : [];

      if (userEnabledRoles.length === 0) {
        return;
      }

      // check cluster_view
      const hasClusterView = userEnabledRoles.includes("Clusters View");
      if (hasClusterView) {
        setIsDesignerEnabled(true);
      }

      if (!hasClusterView) {
        setColumns((prevCols) =>
          prevCols.filter((col) => col.accessor !== "username")
        );
      }
    } catch (err) {
      console.error("Failed to load enabled roles:", err);
    }
  }

  useEffect(() => {
    (async () => {
      await getEnabledRoles();
      setLoading(false);
    })();

    getWizards();
    getDesignObjects();
    dispatch(
      SET_NAVBAR_TITLE(
        isInternal ? account + "  - Design Center" : "Design Center"
      )
    );
  }, []);

  useEffect(() => {
    const { templates, wizards } = reduxDesignStore;
    // setSearchedTemplate(templates);
    setSearchedTemplate(pageNo, recordCount, searchValue);
    setWizards(wizards);
    if (!reduxDesignStore.templates) {
      getTourBlockers(window.location.pathname, "true");
    } else {
      getTourBlockers(window.location.pathname, "false");
    }
  }, [reduxDesignStore, pageNo, recordCount, searchValue]);

  const onRowSelect = (rows) => {
    setSelectedTemplates(rows);
  };
  const handleOpenNetbox = () => {
    window.open("http://criterion-netbox.criterionnetworks.com/", "_blank");
  };

  const getDesignObjects = async () => {
    const designObject = localStorage.getItem("design_objects");
    if (!designObject) {
      const response = await getDesignerObjects();
      if (response.success) {
        localStorage.setItem("design_objects", JSON.stringify(response.data));
      }
    }
  };

  // const getTemplates = async () => {
  //   dispatch(SHOW_LOADER());
  //   const res = await getAllTemplates();
  //   // if (!res.success) {
  //   //   dispatch(SHOW_NOTIFICATION({ payload: res.msg || errPayload }));
  //   //   dispatch(SET_TEMPLATES(res.data));
  //   //   return true;
  //   // }
  //   dispatch(SET_TEMPLATES(res.data));
  //   // dispatch(HIDE_LOADER());
  // };

  const getWizards = async () => {
    const res = await getAllWizards();
    if (!res.success) {
      dispatch(SHOW_NOTIFICATION({ payload: res.msg || errPayload }));
      return true;
    }
    const list_length = Object.keys(res.data).length;
    setlistvalue(list_length);
    dispatch(SET_WIZARDS(res.data));
    dispatch(HIDE_LOADER());
  };
  let slidesToShow = 4;
  if (listvalue < 4) {
    slidesToShow = listvalue;
  }
  const settings = {
    dots: true,
    infinite: true,
    draggable: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    nextArrow: <ArrowForwardIosOutlinedIcon />,
    prevArrow: <ArrowBackIosOutlinedIcon />,
  };

  const handleDelete = () => {
    setConfirmModal(false);
    if (!selectedTemplates.length) return true;

    dispatch(SHOW_LOADER());
    Promise.all(
      selectedTemplates.map((templ) => removeTemplate(templ.original.uuid))
    )
      .then((values) => {
        setSearchedTemplate(pageNo, recordCount, searchValue);
        dispatch(HIDE_LOADER());
        for (let t = 0; t < values.length; t++) {
          if (values[t].success == true) {
            setShowNotification(true);
            setNotificationType("success");
            setNotificationMessage("Successfully deleted the template");
          } else {
            setShowNotification(true);
            setNotificationType("error");
            setNotificationMessage(values[t].msg);
          }
        }
      })
      .catch((e) => {
        dispatch(SHOW_NOTIFICATION({ payload: errPayload }));
        dispatch(HIDE_LOADER());
        setShowNotification(true);
        setNotificationType("error");
        setNotificationMessage("Failed to delete the template");
      });
  };

  const handleConfirmation = () => {
    if (!selectedTemplates.length) return true;
    setConfirmModal(true);
  };

  const handleTemplateView = async (
    name,
    uuid,
    isMultiVM,
    isLiveEdit,
    cluster,
    flavor,
    cloudNative,
    username
  ) => {
    if (
      localStorage.getItem("BASE_URL") == null ||
      localStorage.getItem("BASE_URL") == undefined
    ) {
      const BASE_URL = window.REACT_APP_API_BASE_URL;
      localStorage.setItem("BASE_URL", BASE_URL);
    }
    if (
      localStorage.getItem("design_objects") == null ||
      localStorage.getItem("design_objects") == undefined
    ) {
      var resp = await getDesignerObjects();
      if (resp.success) {
        localStorage.setItem("design_objects", JSON.stringify(resp.data));
      }
    }
    var route;
    if (
      window.location.protocol !== "https:" &&
      window.location.hostname !== "localhost"
    ) {
      if (cluster == "cloudNative" || cloudNative) {
        route =
          `https:${window.location.hostname}` +
          "/design_center/cloud_native.html?";
      } else {
        route = `https:${window.location.hostname}` + "/design_center/?";
      }
    } else {
      if (cluster == "cloudNative" || cloudNative) {
        route = "/design_center/cloud_native.html?";
      } else {
        route = "/design_center/?";
      }
    }
    if (uuid) {
      route = `${route}uuid=${uuid}&user=${username}`;
    } else if (actionWizard) {
      if (isMultiVM) {
        route = `${route}new_template=${name}&title=${actionWizard}&multi_vm=${isMultiVM}`;
      } else {
        route = `${route}new_template=${name}&title=${actionWizard}&liveEdit=${isLiveEdit}`;
      }
    } else {
      if (isMultiVM) {
        route = `${route}new_template=${name}&multi_vm=${isMultiVM}`;
      } else {
        route = `${route}new_template=${name}&liveEdit=${isLiveEdit}`;
      }
    }
    window.location.href = route;
    localStorage.removeItem("CLUSTER_FLAVOR");
    if (flavor) {
      localStorage.setItem("CLUSTER_FLAVOR", flavor);
    }
  };
  const setSearchedTemplate = async (page_no, record_count, search_value) => {
    let templateList = [];
    try {
      const resp = await SDCloudBackendAPIWithToken().get(
        `/designer/template_list?search=${search_value ??
          searchValue}&page_no=${page_no ||
          pageNo}&record_count=${record_count || recordCount}`
      );

      const data = resp.data;

      data.templates.forEach((item) => {
        templateList.push({
          created_at: item.created_at
            ? moment(item.created_at).format("YYYY-MM-DD | HH:mm:ss A")
            : null,
          status: item.status,
          uuid: item.uuid,
          username: item.username,
          name: item.name?.split("|")[0],
          last_used: item.last_used
            ? moment(item.last_used).format("YYYY-MM-DD | HH:mm:ss A")
            : null,
          actions: (
            <div
              id="goto-template"
              onClick={() =>
                handleTemplateView(
                  null,
                  item.uuid,
                  null,
                  null,
                  null,
                  null,
                  item.is_cloud_native,
                  item.username
                )
              }
            >
              <Tooltip
                id="tooltip-top"
                enterDelay={200}
                leaveDelay={200}
                TransitionComponent={Zoom}
                title="Go to template"
                placement="bottom-start"
              >
                <ArrowRightIcon style={{ cursor: "pointer" }} />
              </Tooltip>
            </div>
          ),
        });
      });

      setRows(templateList);
      setrowstemp(data);
    } catch (err) {
      console.error("Failed to fetch templates:", err);

      // Optional: show user-friendly error
      setNotificationMessage(
        err?.response?.data?.message ||
          "Failed to load templates. Please try again."
      );
      setNotificationType("error");
      setShowNotification(true);

      // Fallback UI
      setRows([]);
      setrowstemp({ templates: [] });
    }
  };

  // const setSearchedTemplates = (templates) => {
  //   const updatedList = [];
  //   for (const i in templates) {
  //     // eslint-disable-line
  //     updatedList.push({
  //       ...templates[i],
  //       created_at: templates[i].created_at
  //         ? moment(templates[i].created_at).format("YYYY-MM-DD | HH:mm:ss A")
  //         : null,
  //       status: templates[i].status,
  //       name: templates[i].name?.split("|")[0],
  //       last_used: templates[i].last_used
  //         ? moment(templates[i].last_used).format("YYYY-MM-DD | HH:mm:ss A")
  //         : null,
  //       actions: (
  //         <div onClick={() => handleTemplateView(null, templates[i].uuid, null, null, null,null, templates[i].is_cloud_native)}>
  //           <Tooltip
  //             id="tooltip-top"
  //             enterDelay={200}
  //             leaveDelay={200}
  //             TransitionComponent={Zoom}
  //             title="Go to template"
  //             placement="bottom-start"
  //           >
  //             <ArrowRightIcon style={{ cursor: "pointer" }} />
  //           </Tooltip>
  //         </div>
  //       ),
  //     });
  //   }
  //   setRows(updatedList);
  // };
  const handlePagination = (page_no, record_count) => {
    setrecordCount(record_count);
    setpageNo(page_no);
  };
  const handleChange = (event) => {
    setsearchvalue(event.target.value);
  };

  return (
    <div className="design-page">
      <ConfirmationModal
        visible={isConfirmModal}
        onClose={() => setConfirmModal(false)}
        onConfirm={handleDelete}
        selectedTemplate={selectedTemplates.length}
      />
      {isNewTemplateVisible && (
        <CreateTemplateModal
          visible={isNewTemplateVisible}
          onClose={() => {
            setActionWizard("");
            setNewTemplateVisible(false);
          }}
          actionWizard={actionWizard}
          onCreateTemplate={handleTemplateView}
          is_multi_vm={JSON.parse(localStorage.getItem("profileData")).multi_vm}
          cloud_native_enabled={
            JSON.parse(localStorage.getItem("profileData")).cloud_native_enabled
          }
        />
        // <ImportFromWizard
        //   visible={isNewTemplateVisible}
        //   onClose={() => {
        //     setActionWizard("");
        //     setNewTemplateVisible(false);
        //   }}
        //   actionWizard={actionWizard}
        //   data={allWizards}
        //   open={true}
        //   onCreateTemplate={handleTemplateView}
        //   is_multi_vm={JSON.parse(localStorage.getItem("profileData")).multi_vm}
        //   cloud_native_enabled ={JSON.parse(localStorage.getItem("profileData")).cloud_native_enabled}
        // />
      )}
      {isNewTemplateWizardVisible && (
        // <CreateTemplateModal
        //   visible={isNewTemplateWizardVisible}
        //   onClose={() => {
        //     setActionWizard("");
        //     setNewTemplateWizardVisible(false);
        //   }}
        //   actionWizard={actionWizard}
        //   onCreateTemplate={handleTemplateView}
        //   is_multi_vm={JSON.parse(localStorage.getItem("profileData")).multi_vm}
        //   cloud_native_enabled ={JSON.parse(localStorage.getItem("profileData")).cloud_native_enabled}
        // />
        <ImportFromWizard
          visible={isNewTemplateWizardVisible}
          onClose={() => {
            setActionWizard("");
            setNewTemplateWizardVisible(false);
          }}
          actionWizard={actionWizard}
          data={allWizards}
          open={true}
          onCreateTemplate={handleTemplateView}
          is_multi_vm={JSON.parse(localStorage.getItem("profileData")).multi_vm}
          cloud_native_enabled={
            JSON.parse(localStorage.getItem("profileData")).cloud_native_enabled
          }
        />
      )}
      {!is_designer_enabled ? (
        <div className="design-card design-card2">
          <DesignCenterUpgrade />
        </div>
      ) : (
        <GridContainer>
          <GridItem md={12}>
            {showNotification ? (
              <Alert
                onClose={() => setShowNotification(false)}
                severity={notificationType}
              >
                {notificationMessage}
              </Alert>
            ) : null}
          </GridItem>
          <Grid container spacing={4} className="bg-gray pt-4 d-card ">
            <Grid item xs={12} sm={3} className=" ">
              <div class="design-create-card" id="create-design">
                <p class={`create-card-title ${classes.font}`}>
                  Create New Design
                </p>
                <button
                  className={`${"" +
                    " " +
                    classes.font} button new-design-button`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setNewTemplateVisible(true)}
                >
                  {" "}
                  <img src={plus} className="" /> <br />{" "}
                </button>
              </div>
            </Grid>
            <Grid item xs={12} sm={2} className=" ">
              <div class="design-create-card" id="design-from-wizard">
                <p class={`create-card-title ${classes.font}`}>
                  New Design From Wizard
                </p>
                <button
                  className={`${classes.font}`}
                  style={{ cursor: "pointer", width: "100px", height: "80px" }}
                  onClick={() => setNewTemplateWizardVisible(true)}
                >
                  {" "}
                  <img src={topology} className="" /> <br />{" "}
                </button>
              </div>
            </Grid>
            <Grid item xs={12} sm={2} className=" ">
              <div class="design-create-card" id="import-xml">
                <p class={`create-card-title ${classes.font}`}>
                  Import Design from XML
                </p>
                <button
                  className={`${classes.font} `}
                  style={{ cursor: "pointer", width: "100px", height: "80px" }}
                  onClick={() => {
                    setIsImportModal(true);
                    setModalType("XML");
                  }}
                >
                  {" "}
                  <img src={xml} className="" /> <br />{" "}
                </button>
              </div>
            </Grid>
            <Grid item xs={12} sm={2} className=" ">
              <div class="design-create-card" id="import-yaml">
                <p class={`create-card-title ${classes.font}`}>
                  Import Design from YAML
                </p>
                <button
                  className={`${classes.font} `}
                  style={{ cursor: "pointer", width: "100px", height: "80px" }}
                  onClick={() => {
                    setIsImportModal(true);
                    setModalType("YAML");
                  }}
                >
                  {" "}
                  <img src={yaml} className="" /> <br />{" "}
                </button>
              </div>
            </Grid>
            <Grid item xs={12} sm={3} className=" ">
              <div class="design-create-card" id="criterion-netbox">
                <p class={`create-card-title ${classes.font}`}>
                  Criterion Netbox
                </p>
                <button
                  className={`${classes.font} `}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpenNetbox()}
                >
                  {" "}
                  <img src={netbox} className="" /> <br />{" "}
                </button>
              </div>
            </Grid>

            {/* <Grid item xs={12} sm={2} className=" ">
              <div class="design-create-card">
                <p
                  class={`create-card-title ${classes.font}`}
                  style={{ color: "lightgray" }}
                >
                  Import Design
                </p>
                <button
                  className={`button download-design-button ${classes.font}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsImportModal(true)}
                >
                  {" "}
                  <img src={download} className="" /> <br /> Import{" "}
                </button>
              </div>
            </Grid> */}
          </Grid>

          <Grid container spacing={3} className="bg-gray pt-3 ">
            <Grid item xs={11} sm={11} className=" ">
              <p class={`mydesign-title ${classes.font}`}>My Designs</p>
            </Grid>
          </Grid>
          {/* <GridItem className="new-template" md={4}>
            <div className="label">Create new template</div>
            <div className="content">
              <FeatureBox
                className="mr-45"
                icon={plusIcon}
                active
                label="New graph (Manually)"
                action={() => setNewTemplateVisible(true)}
              />             
            </div>
          </GridItem> */}
          {/* <GridItem className="wizard" md={8}>
            <div className="label">From wizard</div>
            <div className="content">
              <Slider {...settings}>
                {Object.keys(allWizards || {}).map((key, index) => {
                  const wizard = allWizards[key];
                  return (
                    <FeatureBox
                      key={index}
                      icon={wizard.image}
                      label={wizard.title}
                      action={() => {
                        setActionWizard(wizard.title);
                        setNewTemplateVisible(true);
                      }}
                      iconClass="size35"
                    />
                  );
                })}
              </Slider>
            </div>
          </GridItem> */}
          <GridItem className="list-view" md={12}>
            <div className="search-header">
              <Grid
                container
                className={classes.headerContainer}
                alignItems="center"
                justify="space-between"
                wrap="wrap"
                style={{ margin: "23px 0" }}
              >
                <Grid className="first-col" item xs={12} sm={12} md={12}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    disableElevation
                    size="large"
                    fullWidth
                    disableFocusRipple
                    className="gray-btn trash"
                    onClick={handleConfirmation}
                  >
                    <span>
                      <img alt="trash" src={deleteicon} />
                    </span>
                  </Button>
                  <TextField
                    type="search"
                    variant="filled"
                    className="search-input"
                    fullWidth
                    onChange={(event) => {
                      handleChange(event);
                    }}
                    value={searchValue}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </div>
            {/* <SearchHeader
              handleDelete={handleConfirmation}
              setSearchList={setSearchedTemplate}
              // templates={reduxDesignStore.templates || []}
              value={searchValue}
              onChange={(event) => {
                handleChange(event);
              }}
            /> */}
            <div id="design-table">
              {loading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "80px",
                  }}
                >
                  <LoaderHoc isLoading={loading}></LoaderHoc>
                </div>
              ) : (
                <CustomTable
                  data={rows}
                  columns={columns}
                  onRowSelect={onRowSelect}
                  handleTemplateView={handleTemplateView}
                  isRowSelection
                  count={rowstemp?.pagination?.total_pages}
                  page_no={rowstemp?.pagination?.current_page}
                  setTemplatesList={handlePagination}
                />
              )}
            </div>
          </GridItem>
        </GridContainer>
      )}
      {isImportModal && (
        <ImportDesignModal
          onCreateTemplate={handleTemplateView}
          visible={isImportModal}
          modalType={modalType}
          onClose={() => {
            setActionWizard("");
            setIsImportModal(false);
          }}
        />
      )}
      <Chatbot />
    </div>
  );
}
